export const companyInfo = {
  name: "SOFTCONCERN TECHNOLOGIES LLP",
  llpin: "AAQ-4263",
  founded: "30 Dec 2019",
  email: "softconcern@gmail.com",
  phone: "+91 9405490959",
  address: {
    full: "FL 12, Sadafuli B, Plot No. 18, S No 78, Bhusari Colony, Pune, Maharashtra, India – 411038",
    city: "Pune",
    state: "Maharashtra",
    country: "India",
    pincode: "411038"
  },
  socialMedia: {
    linkedin: "https://linkedin.com/company/softconcern-technologies",
    twitter: "https://twitter.com/softconcern",
    facebook: "https://facebook.com/softconcern"
  }
};

export const heroContent = {
  headline: "Empowering Your Business with AI-Driven IT Solutions",
  subheadline: "Innovative, scalable, and secure technology services tailored to your business needs.",
  ctaButtons: [
    { text: "Get Started", href: "/contact", primary: true },
    { text: "Our Services", href: "/services", primary: false }
  ]
};

export const aboutPreview = {
  title: "What We Do",
  content: "At SOFTCONCERN TECHNOLOGIES LLP, we provide cutting-edge IT solutions including AI automation, custom software development, cloud solutions, and IT consulting to help businesses streamline operations and achieve growth."
};

export const featuredServices = [
  {
    id: 1,
    title: "AI Agents",
    description: "Automate business tasks and enhance customer interactions with our intelligent AI agents.",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Custom Software Development",
    description: "We develop tailored web and mobile applications to meet your unique business requirements.",
    icon: "Code"
  },
  {
    id: 3,
    title: "Cloud Solutions",
    description: "Scalable and secure cloud infrastructure to support your operations seamlessly.",
    icon: "Cloud"
  },
  {
    id: 4,
    title: "IT Consulting",
    description: "Expert guidance to optimize IT strategies, infrastructure, and digital transformation.",
    icon: "Users"
  }
];

export const industries = [
  {
    name: "E-commerce",
    description: "Robust solutions to scale online stores and enhance customer experiences.",
    icon: "ShoppingCart"
  },
  {
    name: "Healthcare",
    description: "Secure, compliant systems to manage patient data and streamline operations.",
    icon: "Heart"
  },
  {
    name: "Education",
    description: "Innovative tools to enhance learning, administration, and collaboration.",
    icon: "BookOpen"
  },
  {
    name: "Finance",
    description: "Reliable systems for managing financial transactions and data securely.",
    icon: "CreditCard"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Smith",
    company: "TechCorp Solutions",
    content: "SOFTCONCERN transformed our business processes with their AI automation solutions. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Johnson",
    company: "HealthFirst Clinic",
    content: "Their custom software development exceeded our expectations. Professional team and excellent delivery.",
    rating: 5
  },
  {
    id: 3,
    name: "Mike Davis",
    company: "EduTech Platform",
    content: "Outstanding cloud solutions that scaled perfectly with our growing business needs.",
    rating: 5
  }
];

export const aboutUs = {
  overview: {
    title: "About SOFTCONCERN TECHNOLOGIES LLP",
    content: "SOFTCONCERN TECHNOLOGIES LLP (LLPIN: AAQ-4263), incorporated on 30 Dec 2019, is a trusted IT solutions provider registered with the Registrar of Companies, Pune. We specialize in delivering innovative technology solutions that help businesses achieve operational excellence and growth."
  },
  mission: {
    title: "Our Mission",
    content: "To empower businesses with technology solutions that enhance efficiency, foster innovation, and drive growth."
  },
  vision: {
    title: "Our Vision",
    content: "To be a leading provider of IT solutions, recognized for excellence, reliability, and customer satisfaction."
  },
  values: [
    {
      title: "Innovation",
      description: "Continuously exploring new technologies to provide cutting-edge solutions."
    },
    {
      title: "Integrity",
      description: "Conducting business with honesty, transparency, and accountability."
    },
    {
      title: "Customer-Centricity",
      description: "Prioritizing our clients' needs in every solution we deliver."
    }
  ],
  partners: {
    title: "Our Designated Partners",
    content: "Pankaj Govindrao Takale and Jyoti Deepak Shinde lead our team with a focus on innovation, integrity, and excellence in IT services."
  }
};

export const services = [
  {
    id: 1,
    category: "AI Automation",
    title: "Intelligent Automation Solutions",
    description: "Implement intelligent automation solutions to streamline operations and improve efficiency.",
    keyOfferings: ["AI Chatbots", "Voice Assistants", "Automated Workflows", "Process Automation"],
    icon: "Brain"
  },
  {
    id: 2,
    category: "Custom Software Development",
    title: "Tailored Software Solutions",
    description: "Bespoke web and mobile applications tailored to your business requirements.",
    keyOfferings: ["Web Applications", "Mobile Apps", "Enterprise Solutions", "API Development"],
    icon: "Code"
  },
  {
    id: 3,
    category: "Cloud Solutions",
    title: "Scalable Cloud Infrastructure",
    description: "Secure and scalable cloud infrastructure to support seamless business operations.",
    keyOfferings: ["Cloud Migration", "Cloud Hosting", "Disaster Recovery", "Infrastructure Management"],
    icon: "Cloud"
  },
  {
    id: 4,
    category: "IT Consulting",
    title: "Strategic IT Guidance",
    description: "Expert IT guidance to optimize strategy, infrastructure, and digital transformation.",
    keyOfferings: ["IT Strategy Planning", "Infrastructure Assessment", "Technology Roadmap", "Digital Transformation"],
    icon: "Users"
  },
  {
    id: 5,
    category: "Digital Transformation Solutions",
    title: "Business Modernization",
    description: "Modernize your business processes with innovative digital solutions.",
    keyOfferings: ["Workflow Automation", "AI-driven Analytics", "Business Intelligence", "Digital Strategy"],
    icon: "Zap"
  }
];

export const technologies = {
  frontend: [
    { name: "React.js", icon: "⚛️" },
    { name: "Vue.js", icon: "💚" },
    { name: "Angular", icon: "🔺" },
    { name: "TypeScript", icon: "📘" }
  ],
  backend: [
    { name: "Node.js", icon: "🟢" },
    { name: "Python", icon: "🐍" },
    { name: "Java", icon: "☕" },
    { name: "PHP", icon: "🐘" }
  ],
  database: [
    { name: "MySQL", icon: "🐬" },
    { name: "PostgreSQL", icon: "🐘" },
    { name: "MongoDB", icon: "🍃" },
    { name: "Redis", icon: "🔴" }
  ],
  cloud: [
    { name: "AWS", icon: "🟠" },
    { name: "Google Cloud", icon: "🟦" },
    { name: "Microsoft Azure", icon: "🔵" },
    { name: "DigitalOcean", icon: "🟢" }
  ],
  devops: [
    { name: "Docker", icon: "🐋" },
    { name: "Kubernetes", icon: "⎈" },
    { name: "Jenkins", icon: "🏗️" },
    { name: "GitHub Actions", icon: "⚡" }
  ],
  aiTools: [
    { name: "n8n", icon: "🔗" },
    { name: "Zapier", icon: "⚡" },
    { name: "Dialogflow", icon: "💬" },
    { name: "OpenAI", icon: "🤖" }
  ]
};

export const blogCategories = [
  "AI & Automation",
  "Software Development",
  "Cloud Computing",
  "IT Strategy"
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of AI Automation in Business",
    excerpt: "Explore how AI automation is revolutionizing business processes and driving efficiency across industries.",
    category: "AI & Automation",
    readTime: "5 min read",
    date: "2024-01-15",
    author: "Pankaj Takale"
  },
  {
    id: 2,
    title: "Best Practices for Custom Software Development",
    excerpt: "Learn the essential practices that ensure successful custom software development projects.",
    category: "Software Development",
    readTime: "8 min read",
    date: "2024-01-10",
    author: "Jyoti Shinde"
  },
  {
    id: 3,
    title: "Cloud Migration Strategies for SMEs",
    excerpt: "A comprehensive guide to successful cloud migration strategies for small and medium enterprises.",
    category: "Cloud Computing",
    readTime: "6 min read",
    date: "2024-01-08",
    author: "Pankaj Takale"
  },
  {
    id: 4,
    title: "Digital Transformation: A Strategic IT Approach",
    excerpt: "How to approach digital transformation with strategic IT planning and implementation.",
    category: "IT Strategy",
    readTime: "7 min read",
    date: "2024-01-05",
    author: "Jyoti Shinde"
  }
];

export const ctaSection = {
  title: "Ready to Transform Your Business?",
  content: "Contact us today to discuss how our solutions can help you succeed.",
  buttonText: "Contact Us",
  buttonHref: "/contact"
};